import { render, staticRenderFns } from "./OurPlatformPage.vue?vue&type=template&id=1fe908b8"
import script from "./OurPlatformPage.vue?vue&type=script&lang=js"
export * from "./OurPlatformPage.vue?vue&type=script&lang=js"
import style0 from "./OurPlatformPage.vue?vue&type=style&index=0&id=1fe908b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports